var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddress = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11407_18954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99784 0C6.04886 0 2.85498 3.13 2.85498 7C2.85498 12.25 9.99784 20 9.99784 20C9.99784 20 17.1407 12.25 17.1407 7C17.1407 3.13 13.9468 0 9.99784 0ZM9.99784 9.5C8.58967 9.5 7.44682 8.38 7.44682 7C7.44682 5.62 8.58967 4.5 9.99784 4.5C11.406 4.5 12.5489 5.62 12.5489 7C12.5489 8.38 11.406 9.5 9.99784 9.5Z",
    fill: "#BEAEFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11407_18954"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddress);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/address.67c0dbc4046677df8be08c47593c479b.svg";